import React, { useEffect, useRef } from 'react';
import { Modal } from 'antd';
import IconFont from '$/components/IconFont';
import { useLanguageStore } from '$/store/languageStore';
import { useOfficialStore } from '$/store/useOfficialStore';
import {
  getAssetStorageInfo,
  getAssetStorageLimitUpgradeText,
  getAssetStorageProgressBarStyle,
} from '$/utils/assetStorage';
import { trackRoboneoVipClick, trackRoboneoVipShow } from '$/utils/vipPromptTrack';
import styles from './index.module.scss';

interface AssetStorageLimitModalProps {
  open: boolean;
  zIndex?: number;
  onClose: () => void;
  onAction: () => void;
}

/** 资产库容量不足弹窗，统一承载升级容量和最高等级会员反馈入口，并要求用户通过显式入口关闭。 */
function AssetStorageLimitModal({
  open,
  zIndex = 3200,
  onClose,
  onAction,
}: AssetStorageLimitModalProps) {
  const languageStore = useLanguageStore((state) => state.languageStore);
  const subscribe = useOfficialStore((state) => state.userInfo.subscribe);
  const info = getAssetStorageInfo(subscribe);
  const progressBarStyle = getAssetStorageProgressBarStyle(info);
  const ctaText = info.isHighestLevel
    ? languageStore.smartcatTranslationText((v) => v.contact_us)
    : getAssetStorageLimitUpgradeText();
  const exposedRef = useRef(false);

  useEffect(() => {
    if (open && !exposedRef.current) {
      trackRoboneoVipShow('asset_node_upgrade');
    }
    exposedRef.current = open;
  }, [open]);

  /** 点击容量弹窗 CTA；最高等级会员仅进入反馈，其余用户补报会员升级点击。 */
  const handleActionClick = () => {
    if (!info.isHighestLevel) {
      trackRoboneoVipClick('asset_node_upgrade');
    }
    onAction();
  };

  return (
    <Modal
      open={open}
      centered
      footer={null}
      width={320}
      zIndex={zIndex}
      closable={false}
      className={styles.assetStorageLimitModal}
      maskClosable={false}
      onCancel={onClose}
      destroyOnClose
    >
      <div className={styles.modalRoot}>
        <button
          type="button"
          className={styles.closeButton}
          onClick={onClose}
          aria-label={languageStore.smartcatTranslationText((v) => v.RoboNeo_Web_sidebar_close)}
        >
          <IconFont name="crossBlack" fontSize={20} color="currentColor" />
        </button>
        <div className={styles.title}>
          {languageStore.smartcatTranslationText((v) => v.insufficient_asset_storage_space)}
        </div>
        <div className={styles.capacityPanel}>
          <div className={styles.capacityRow}>
            <span>{languageStore.smartcatTranslationText((v) => v.capacity_1)}</span>
            <span>{info.usageLabel}</span>
          </div>
          <div className={styles.progressTrack}>
            <span className={styles.progressBar} style={progressBarStyle} />
          </div>
        </div>
        <button type="button" className={styles.actionButton} onClick={handleActionClick}>
          {ctaText}
        </button>
      </div>
    </Modal>
  );
}

export default AssetStorageLimitModal;
